import { calculatePersonalTaxInfo } from "./personal_tax_helper";
import { calculateCorporateTaxInfo } from "./corporate_tax_helper";
import VAT_CONFIG from "@/configs/vat_config.json";

const VAT_RATE = 0.07;

export function calculateVatComparation({
  sellingPrice,
  purchasePrice,
  sellPriceHasExcludeVat,
  purchasePriceHasExcludeVat,
  aIsRegister,
  bIsRegister,
  isPersonal,
}) {
  let sellingPriceExcludeVat = sellPriceHasExcludeVat
    ? sellingPrice
    : sellingPrice / (1 + VAT_RATE);
  let purchasePriceExcludeVat = purchasePriceHasExcludeVat
    ? purchasePrice
    : purchasePrice / (1 + VAT_RATE);
  let sellingVat = sellingPriceExcludeVat * VAT_RATE;
  let purchaseVat = purchasePriceExcludeVat * VAT_RATE;

  if (aIsRegister) {
    if (bIsRegister) {
      // Don't do anything
    } else {
      purchaseVat = 0;
      purchasePriceExcludeVat = purchasePrice;
    }
  } else {
    if (bIsRegister) {
      sellingVat = 0;
      purchaseVat = 0;
      purchasePriceExcludeVat = purchasePrice;
    } else {
      // No this case
    }
  }

  const vat = sellingVat - purchaseVat;
  const tax = isPersonal
    ? calculatePersonalTaxInfo({
        incomes: {
          onlineSelling: {
            income: sellingPriceExcludeVat,
            expense: bIsRegister ? purchasePriceExcludeVat : 0,
          },
        },
        deducts: {},
      }).tax
    : calculateCorporateTaxInfo({
        incomes: {
          onlineSelling: {
            income: sellingPriceExcludeVat,
            expense: bIsRegister ? purchasePriceExcludeVat : 0,
          },
        },
      }).tax;

  const netCash =
    sellingPriceExcludeVat +
    sellingVat -
    purchasePriceExcludeVat -
    purchaseVat -
    vat;
  const cashFlow = netCash - tax;

  return {
    sellingPriceExcludeVat,
    sellingVat,
    purchasePriceExcludeVat,
    purchaseVat,
    vat,
    tax,
    netCash,
    cashFlow,
  };
}

export function calculatePersonalRegisterVat(data) {
  let sellingVat = 0;
  let purchaseVat = 0;
  let vat = 0;
  let tax = 0;
  let netCash = 0;
  let cashFlow = 0;
  const sellingPrice = parseFloat(data.sellingPrice) * 12;
  const sellingPriceExcludeVat = sellingPrice / 1.07;
  sellingVat = sellingPrice - sellingPriceExcludeVat;

  const purchasePrice = parseFloat(data.purchasePrice) * 12;
  let purchasePriceExcludeVat = purchasePrice;

  if (data.isRegister) {
    purchasePriceExcludeVat = purchasePrice / 1.07;
    purchaseVat = purchasePrice - purchasePriceExcludeVat;
  }

  tax = calculatePersonalTaxInfo({
    incomes: {
      onlineSelling: {
        income: sellingPriceExcludeVat,
        expense: purchasePriceExcludeVat,
      },
    },
    deducts: {},
  }).tax;

  vat = Math.max(0, sellingVat - purchaseVat);

  netCash = Math.max(
    0,
    sellingPriceExcludeVat +
      sellingVat -
      purchasePriceExcludeVat -
      purchaseVat -
      vat
  );

  cashFlow = Math.max(0, netCash - tax);

  return {
    sellingPriceExcludeVat,
    purchasePriceExcludeVat,
    sellingVat: sellingVat,
    purchaseVat: purchaseVat,
    vat: vat,
    tax: tax,
    netCash: netCash,
    cashFlow: cashFlow,
  };
}

export function calculatePersonalVatInfo(data) {
  let sellingVat = 0;
  let purchaseVat = 0;
  let vat = 0;
  let tax = 0;
  let netCash = 0;
  let cashFlow = 0;
  let cost = 0;
  const sellingPriceExcludeVat = parseFloat(data.sellingPrice) * 12;
  sellingVat = sellingPriceExcludeVat * VAT_CONFIG.VAT_RATE;

  const purchasePriceExcludeVat = parseFloat(data.purchasePrice) * 12;

  if (data.hasPurchaseVat) {
    purchaseVat = purchasePriceExcludeVat * VAT_CONFIG.VAT_RATE;
    cost = purchasePriceExcludeVat;
  } else {
    cost = 0;
  }

  tax = calculatePersonalTaxInfo({
    incomes: {
      onlineSelling: {
        income: sellingPriceExcludeVat,
        expense: cost,
      },
    },
    deducts: {},
  }).tax;

  vat = Math.max(0, sellingVat - purchaseVat);

  netCash = Math.max(
    0,
    sellingPriceExcludeVat +
      sellingVat -
      purchasePriceExcludeVat -
      purchaseVat -
      vat
  );

  cashFlow = Math.max(0, netCash - tax);

  return {
    sellingPriceExcludeVat,
    purchasePriceExcludeVat,
    sellingVat: sellingVat,
    purchaseVat: purchaseVat,
    vat: vat,
    tax: tax,
    netCash: netCash,
    cashFlow: cashFlow,
  };
}

export function calculateCorporateVatInfo(data) {
  let sellingVat = 0;
  let purchaseVat = 0;
  let vat = 0;
  let tax = 0;
  let netCash = 0;
  let cashFlow = 0;
  let cost = 0;

  const sellingPriceExcludeVat = parseFloat(data.sellingPrice) * 12;

  sellingVat = sellingPriceExcludeVat * VAT_CONFIG.VAT_RATE;

  const purchasePriceExcludeVat = parseFloat(data.purchasePrice) * 12;

  if (data.hasPurchaseVat) {
    purchaseVat = purchasePriceExcludeVat * VAT_CONFIG.VAT_RATE;
    cost = purchasePriceExcludeVat;
  } else {
    cost = 0;
  }

  vat = Math.max(0, sellingVat - purchaseVat);

  tax = calculateCorporateTaxInfo({
    income: {
      onlineSelling: {
        income: sellingPriceExcludeVat,
        expense: cost,
      },
    },
  }).tax;

  netCash = Math.max(
    0,
    sellingPriceExcludeVat +
      sellingVat -
      purchasePriceExcludeVat -
      purchaseVat -
      vat
  );
  cashFlow = Math.max(0, netCash - tax);

  return {
    sellingPriceExcludeVat,
    purchasePriceExcludeVat,
    sellingVat: sellingVat,
    purchaseVat: purchaseVat,
    vat: vat,
    tax: tax,
    netCash: netCash,
    cashFlow: cashFlow,
  };
}
